<template>

	<div class="dropdown-item ">
		<div class="dropdown-intro" >
      <DrowdownLine :is-expanded="isExpanded" :cb="toggleExpanded">
				Volledige projectenlijst
			</DrowdownLine>

			<Collapse :when="isExpanded" class="projects mt-sm">
				<div v-for="(project, index) in projects" :key="'project-' + index" class="project mb-sm">
          <div class="project-title"> 
            <a :href="project['project_url']" target="_blank">
              {{ project['Naam'] }}
            </a>
          </div>

          <div class="project-info">
            <div class="project-type ta-center"> 
              <div class="project-label">Type project:</div>
              <div class="project-type-icon">
                <img :src="getIcon(project['type'])" />
              </div>
              <div class="project-type-value">
                {{ project['type'] }}
              </div>
            </div>

            <div class="project-combined">
              <div class="project-start">
                <span class="project-label">Bouwjaar: </span>
                <span class="project-value">{{ project['Startjaar project'] }}</span>
              </div>
              <div class="project-country">
                <span class="project-label">Land: </span>
                <span class="project-value">{{ project['Land'] }}</span>
              </div>
            </div>
            <div class="project-kind ta-center" :class="getClassName(project['soort'])">
              <div class="project-label">Soort project:</div>
              {{ project['soort'] }}
            </div>
          </div>
        </div>

        <DrowdownLine :is-expanded="isExpanded" :cb="toggleExpanded">
          Verberg volledige projectenlijst
        </DrowdownLine>

			</Collapse>
		</div>
	</div>
</template>

<script setup>
  import { defineProps, reactive, ref, watch } from "vue";
  import { Collapse } from 'vue-collapsed';
	import { useStore } from 'vuex';
	const store = useStore()

  import DrowdownLine from '@/story/risicos/dropdown-line.vue';

  const props = defineProps({
    projects: Array
  });

  watch(() => store.getters.selectedCompanyName, function() {
    isExpanded.value = false;
   });


  function getIcon(key) {
    try {
      return require(`@/assets/icons/${ key.toLowerCase()}.svg`);
    } catch {
      return require(`@/assets/icons/placeholder.svg`);
    }
  }

  function getClassName(soort) {
    if (soort) {
      return 'kind-' + soort.toLowerCase()
    }
  }

  const isExpanded = ref(false);
  const toggleExpanded = () => {
    isExpanded.value = !isExpanded.value;
  }
</script>

<style lang="scss" scoped>
	.dropdown-item {
		background: var(--lightblue);
		padding: 2rem;

    max-height: 800px;
    overflow-y: auto;

    .projects {
      color: var(--moss);
    }

    .title {
      margin-bottom: 0;
    }
	}

  .project {
    background: var(--moss);
    color: var(--off-white);
    border: 2px solid var(--moss);

    .project-label {
      font-weight: 600;
    }

    .project-title {
      font-size: 1.2em;
      font-family: var(--font-header);
      padding: 2rem;
    }

    .project-info {
      background: var(--off-white);
      color: var(--moss);
      display: flex;
      justify-content: space-between;
      
      & > * {
        flex: 1 100%;
        border-right: 2px solid var(--moss);

        &:last-of-type {
          border-right: none;
        }
      }

      .project-start {
        border-bottom: 2px solid var(--moss);
      }

      .project-country, .project-type, .project-start, .project-kind {
        padding: 1rem;
      }

      .project-type-icon {
        text-align: center;
        margin: 0 auto;
        width: 50px;
      }
    }
    .project-kind {
      &.kind-verminderen {
        background: var(--verminderen);
      }
  
      &.kind-vermijding {
        background: var(--vermijden);

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

      }
  
      &.kind-verwijderen {
        background: var(--verwijderen);
      }
    }

  }

</style>